import { Col, Container, Row } from 'react-bootstrap'
import imgTex from "../Assets/images/Group (15).png"
import img19 from "../Assets/images/Frame 82.png"
import img20 from "../Assets/images/Frame 86.png"
import img21 from "../Assets/images/Frame 87.png"
import img22 from "../Assets/images/Frame 89.png"
import img23 from "../Assets/images/Frame 90.png"
import img24 from "../Assets/images/Frame 98.png"
import { useTranslation } from 'react-i18next';
import headerImg from "../Assets/images/k12.png"
import ProgramHighlights from '../Components/programHighlights/ProgramHighlights';
import WhatYouGetSection from '../Components/whatYouGetSection/WhatYouGetSection';
import duration from "../Assets/images/duration.png";
import format from "../Assets/images/format.png";
import level from "../Assets/images/levels.png";
import certification from "../Assets/images/certification.png";
import whatYouGetImg from "../Assets/images/wul2.png"
import WhoThisProgramIsFor from '../Components/WhoThisProgramIsFor/WhoThisProgramIsFor';
import img26 from "../Assets/images/6.png";
import img27 from "../Assets/images/7.png";
import img28 from "../Assets/images/8.png";
import img29 from "../Assets/images/9.png";
import img30 from "../Assets/images/10.png";
import { useState } from 'react'
import { Modal } from 'antd'
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup'

function KalemonK12() {

    const { t } = useTranslation();

    const [isModalOpen, setIsModalOpen] = useState(false);

   
        const cardsData = [
        { title: t("duration"), details: t("kalemon_k12_cardData.duration_details"), img: duration },
        { title: t("format"), details: t("kalemon_k12_cardData.format_details"), img: format },
        { title: t("level"), details: t("kalemon_k12_cardData.level_details"), img: level },
        { title: t("certification"), details: t("kalemon_k12_cardData.certification_details"), img: certification },
    ];
 const whatYouGetData = [
        { description: t("spiral_curriculum") },
        { description: t("student_teacher_editions") },
        { description: t("phonetics_vocab_grammar") },
        { description: t("digital_content") },
        { description: t("support_materials") },
    ]

        
    const whatProgramFor = [
        { img: img26, title: t("international_schools"), desc: t("international_schools_desc") },
        { img: img27, title: t("k12_learners"), desc: t("k12_learners_desc") },
        { img: img28, title: t("school_systems"), desc: t("school_systems_desc") },
        { img: img29, title: t("educational_administrators"), desc: t("educational_administrators_desc") },
        { img: img30, title: t("homeschooling_families"), desc: t("homeschooling_families_desc") },
    ];

    return (
        <div className='kalemon-k12 '>
            <section className='arabicLife-sec'>
                <div className='first-section position-relative'>
                    <Row className='justify-content-start flex-column gx-0'>
                        <Col md={12} className='content-box'>
                            <Container>
                                {/* <img src={img2} alt='' className='my-4' /> */}
                                <h2 className='mb-3' style={{ marginTop: "150px" }}>{t("kalemon_k12")}</h2>
                                <h5 className='mb-4'>
                                    {t("kalemon_intro")}
                                </h5>

                            </Container>
                        </Col>

                    </Row>
                    <Row className='justify-content-start flex-column '>
                        <Col md={12} className='green-div'>
                            <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                                <Container>   <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>{t("start_now")}</button></Container>
                            </div>


                        </Col>

                    </Row>
                    <img src={headerImg} alt='' className='ar-life-logo' />
                </div>
            </section>

            <section>
                <Container>
                    <ProgramHighlights cardsData={cardsData} color='#CADFC4' />
                    <WhatYouGetSection data={whatYouGetData} img={whatYouGetImg} />
                </Container>
            </section>
            <section className='my-5'>
                <WhoThisProgramIsFor data={whatProgramFor} />
            </section>
            <section className='my-5 k12-grade'>
                <Container>
                    <h2 className='text-center'>{t("k12_program_grade_levels")}</h2>
                    <p className='text-center'>{t("k12_program_desc")}</p>
                </Container>
            </section>

            <div className='seconed-section mt-5'>

                <div className='fourth-section'>
                    <Container>
                        <div className='relative-sec'>
                            <Row>
                                <Col md={2} >
                                    <img src={img19} alt='' className='floatedImg k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                </Col>
                                <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                    <img src={imgTex} alt='' />
                                    <div>
                                        <h6> {t("kalemon.intro_title")} </h6>
                                        <h5> {t("kalemon.intro_desc")}</h5>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className='relative-sec'>
                            <Row>
                                <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                    <img src={imgTex} alt='' />
                                    <div>
                                        <div>
                                            <h6> {t("kalemon.beginner_title")} </h6>
                                            <h5> {t("kalemon.beginner_desc")}</h5>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={2} >
                                    <img src={img20} alt='' className='floatedImg k12-books-items-position2   ' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                </Col>
                            </Row>
                        </div>
                        <div className='relative-sec'>
                            <Row>
                                <Col md={2} >
                                    <img src={img21} alt='' className='floatedImg k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                </Col>
                                <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                    <img src={imgTex} alt='' />
                                    <div>
                                        <h6> {t("kalemon.intermediate_title")} </h6>
                                        <p> {t("kalemon.intermediate_desc")}</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div className='relative-sec'>
                            <Row>
                                <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                    <img src={imgTex} alt='' className='' />
                                    <div>
                                        <h6> {t("kalemon.advanced_title")} </h6>
                                        <p> {t("kalemon.advanced_desc")}</p>
                                    </div>
                                </Col>
                                <Col md={2} >
                                    <img src={img22} alt='' className='floatedImg k12-books' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                </Col>
                            </Row>
                        </div>
                        <div className='relative-sec'>
                            <Row>
                                <Col md={2} >
                                    <img src={img23} alt='' className='floatedImg k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                </Col>
                                <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                    <img src={imgTex} alt='' />
                                    <div>
                                        <h6> {t("kalemon.distinguished_title")} </h6>
                                        <p> {t("kalemon.distinguished_desc")}</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>

                    </Container>
                </div>

                <div className='fifth-section last-sec mb-3'>
                    <Container>
                        <Row className='align-items-center'>
                            <Col md={7}>
                                <h6>{t("transform_education")}</h6>
                                <p className='text-start'>{t("join_international_schools")}</p>
                                <button onClick={() => setIsModalOpen(true)}> {t("kalemon.start_now")} </button>
                            </Col>
                            <Col md={5}>
                                <img src={img24} alt='' className='w-100' />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)}
                width={"80vw"} // close handler
            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>
    )
}

export default KalemonK12
